import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import Button from '@components-clean/core/button';
import LocalStorage from '@utils-clean/local-storage-service';
import { useAuthorization } from '@hooks/index';

const ExceptionPage = () => {
    const [error, setError] = React.useState<string | null>(null);
    const user = useAuthorization();
    const navigate = useNavigate();

    useEffect(() => {
        if (error) {
            setError(null);
            throw Error(error);
        }
    }, [error]);

    const onClick = () => {
        setError('Error');
    };

    const onClickNavbar = () => {
        LocalStorage.setItem(user!, 'ForceNavError', 'Error');
        navigate('/home');
        setTimeout(() => {
            LocalStorage.removeItem(user!, 'ForceNavError');
            navigate('/dummy-components');
            window.location.reload();
        }, 30000);
    };

    return (
        <div>
            <div className="k-pb-2">
                <Button data-testid="throws-error" onClick={onClick} type="submit" primary>
                    Throw Exception
                </Button>
            </div>
            <div>
                <Button data-testid="throws-navbar-error" onClick={onClickNavbar} type="submit" primary>
                    Throw Navbar Exception
                </Button>
            </div>
        </div>
    );
};

export default ExceptionPage;
